

// // client/src/App.js

// import React from "react";
// import "@/index.css";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { Toaster } from "sonner";

// import AppShell from "@/components/layout/AppShell";

// import Dashboard from "@/pages/Dashboard";

// import SeriesList from "@/pages/Series/SeriesList";
// import SeriesDetail from "@/pages/Series/SeriesDetail";
// import CreateSeries from "@/pages/Series/CreateSeries";

// import InvestorData from "@/pages/Investors/InvestorData";
// import InvestorUpload from "@/pages/Investors/InvestorUpload";


// import Calculations from "@/pages/Calculations/Calculations";
// import CalculationDetail from "@/pages/Calculations/CalculationDetail";
// import CreateCalculation from "@/pages/Calculations/CreateCalculation";

// import Reviews from "@/pages/Reviews/Reviews";
// import ReviewDetail from "@/pages/Reviews/ReviewDetail";

// import Payments from "@/pages/Payments/Payments";
// import Redemption from "@/pages/Redemption/Redemption";

// import Reports from "@/pages/Reports/Reports";

// import AuditLog from "@/pages/Audit/AuditLog";

// import Settings from "@/pages/Settings/Settings";

// function App() {
//   return (
//     <BrowserRouter>
//       <Toaster
//         richColors
//         position="top-right"
//       />

//       <Routes>

//         {/* =====================================================
//             EXTERNAL INVESTOR DOCUMENT UPLOAD

//             This route is intentionally outside AppShell.

//             Email link format:
//             /investor-upload/:token

//             Example:
//             http://localhost:3000/investor-upload/eyJhbGciOi...
//             ===================================================== */}
//         <Route
//           path="/investor-upload/:token"
//           element={<InvestorUpload />}
//         />

//         {/* =====================================================
//             INTERNAL APPLICATION
//             ===================================================== */}
//         <Route
//           path="/"
//           element={<AppShell />}
//         >
//           {/* Dashboard */}
//           <Route
//             index
//             element={<Dashboard />}
//           />

//           {/* Series */}
//           <Route
//             path="series"
//             element={<SeriesList />}
//           />

//           <Route
//             path="series/new"
//             element={<CreateSeries />}
//           />

//           <Route
//             path="series/:id"
//             element={<SeriesDetail />}
//           />

//           {/* Investors */}
//           <Route
//             path="investors"
//             element={<InvestorData />}
//           />

//           {/* Calculations */}
//           <Route
//             path="calculations"
//             element={<Calculations />}
//           />

//           <Route
//             path="calculations/new"
//             element={<CreateCalculation />}
//           />

//           <Route
//             path="calculations/:id"
//             element={<CalculationDetail />}
//           />

//           {/* Reviews */}
//           <Route
//             path="reviews"
//             element={<Reviews />}
//           />

//           <Route
//             path="reviews/:id"
//             element={<ReviewDetail />}
//           />

//           {/* Payments */}
//           <Route
//             path="payments"
//             element={<Payments />}
//           />

//           {/* Redemption */}
//           <Route
//             path="redemption"
//             element={<Redemption />}
//           />

//           {/* Reports */}
//           <Route
//             path="reports"
//             element={<Reports />}
//           />

//           {/* Audit */}
//           <Route
//             path="audit"
//             element={<AuditLog />}
//           />

//           {/* Settings */}
//           <Route
//             path="settings"
//             element={<Settings />}
//           />
//         </Route>

//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;



// client/src/App.js

import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import AppShell from "@/components/layout/AppShell";

import Dashboard from "@/pages/Dashboard";

import SeriesList from "@/pages/Series/SeriesList";
import SeriesDetail from "@/pages/Series/SeriesDetail";
import CreateSeries from "@/pages/Series/CreateSeries";

import InvestorData from "@/pages/Investors/InvestorData";
import InvestorUpload from "@/pages/Investors/InvestorUpload";
import InvestorUploadAuth from "@/pages/Investors/InvestorUploadAuth";

import Calculations from "@/pages/Calculations/Calculations";
import CalculationDetail from "@/pages/Calculations/CalculationDetail";
import CreateCalculation from "@/pages/Calculations/CreateCalculation";

import Reviews from "@/pages/Reviews/Reviews";
import ReviewDetail from "@/pages/Reviews/ReviewDetail";

import Payments from "@/pages/Payments/Payments";
import Redemption from "@/pages/Redemption/Redemption";

import Reports from "@/pages/Reports/Reports";

import AuditLog from "@/pages/Audit/AuditLog";

import Settings from "@/pages/Settings/Settings";

function App() {
  return (
    <BrowserRouter>
      <Toaster
        richColors
        position="top-right"
      />

      <Routes>

        {/* =====================================================
            EXTERNAL INVESTOR DOCUMENT WORKFLOW

            STEP 1:
            Investor clicks the link received by email.

            Example:
            /investor-upload/<token>

            This MUST open InvestorUploadAuth first.
            ===================================================== */}
        <Route
          path="/investor-upload/:token"
          element={<InvestorUploadAuth />}
        />

        {/* =====================================================
            STEP 2:
            Investor reaches this page ONLY after successful OTP.

            Example:
            /investor-upload/<token>/document
            ===================================================== */}
        <Route
          path="/investor-upload/:token/document"
          element={<InvestorUpload />}
        />

        {/* =====================================================
            INTERNAL APPLICATION
            ===================================================== */}
        <Route
          path="/"
          element={<AppShell />}
        >
          <Route
            index
            element={<Dashboard />}
          />

          {/* Series */}
          <Route
            path="series"
            element={<SeriesList />}
          />

          <Route
            path="series/new"
            element={<CreateSeries />}
          />

          <Route
            path="series/:id"
            element={<SeriesDetail />}
          />

          {/* Investors */}
          <Route
            path="investors"
            element={<InvestorData />}
          />

          {/* Calculations */}
          <Route
            path="calculations"
            element={<Calculations />}
          />

          <Route
            path="calculations/new"
            element={<CreateCalculation />}
          />

          <Route
            path="calculations/:id"
            element={<CalculationDetail />}
          />

          {/* Reviews */}
          <Route
            path="reviews"
            element={<Reviews />}
          />

          <Route
            path="reviews/:id"
            element={<ReviewDetail />}
          />

          {/* Payments */}
          <Route
            path="payments"
            element={<Payments />}
          />

          {/* Redemption */}
          <Route
            path="redemption"
            element={<Redemption />}
          />

          {/* Reports */}
          <Route
            path="reports"
            element={<Reports />}
          />

          {/* Audit */}
          <Route
            path="audit"
            element={<AuditLog />}
          />

          {/* Settings */}
          <Route
            path="settings"
            element={<Settings />}
          />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;